import React from "react";
import classNames from "classnames";
import { DateTime } from "luxon";
import { Props } from "./types";
import { DateTimeInput } from "./dateTimeInput";
import { Safeguard } from "@scenes/safeguard";
import { UseCases } from "@planzone/core";
import styles from "./styles.scss";

function formatStoredDate(iso: string, zone: string): string {
  const dt = DateTime.fromISO(iso, { zone: "utc" }).setZone(zone);
  return dt.isValid ? dt.toLocaleString(DateTime.DATE_SHORT) : "";
}

function DateForm({
  value,
  projectTimezone,
  disabled,
  milestone,
  minDate,
  maxDate,
  submit,
}: Props) {
  return (
    <Safeguard useCases={[UseCases.editMilestone]} context={{ milestone }}>
      {({ canEditMilestone }) => (
        <div>
          {!canEditMilestone ? (
            <div className={classNames(styles.dateForm, styles.readOnly)}>
              <p className={styles.input}>
                {value ? formatStoredDate(value, projectTimezone) : ""}
              </p>
            </div>
          ) : (
            <div className={styles.dateForm}>
              <DateTimeInput
                dateTime={value}
                projectTimezone={projectTimezone}
                placeholder="-"
                isDisabled={disabled}
                readOnly={!canEditMilestone}
                minDate={(() => {
                  const bound = minDate || milestone.minStartDate;
                  if (!bound) return undefined;
                  const dt = DateTime.fromISO(bound, {
                    zone: "utc",
                  }).setZone(projectTimezone);
                  return dt.isValid
                    ? { year: dt.year, month: dt.month - 1, day: dt.day }
                    : undefined;
                })()}
                input={(dateTime) => !disabled && submit(dateTime)}
              />
            </div>
          )}
        </div>
      )}
    </Safeguard>
  );
}

export { DateForm };
